import { useCallback } from "react";
import { SimpleAlert } from "../components/Alerts/Alerts";
import {
  ERROR,
  GALLERY_FOLDERS_CREATE_ERROR,
  GALLERY_FOLDERS_DUPLICATE,
} from "../i18n/keysTranslations";
import { useTranslationApp } from "../lib/i18next";
import { normalizeFolderName } from "../utils/contentFolderUtils";
import { findFolderIDByName } from "../utils/galleryDirectoryUpload";

export const useEnsureGalleryUploadFolder = ({
  folders = [],
  parentFolderID = null,
  onCreateFolder,
}) => {
  const { t } = useTranslationApp();

  return useCallback(
    async ({ name }) => {
      const normalizedName = normalizeFolderName(name);
      if (!normalizedName || typeof onCreateFolder !== "function") return null;

      const existingID = findFolderIDByName({
        folders,
        parentFolderID,
        name: normalizedName,
      });
      if (existingID) return existingID;

      const response = await onCreateFolder({
        name: normalizedName,
        parentFolderID,
      });

      if (response?.ok && response.data?.id) return response.data.id;

      await SimpleAlert({
        icon: "error",
        title: t(ERROR),
        text: t(
          response?.reason === "duplicateName"
            ? GALLERY_FOLDERS_DUPLICATE
            : GALLERY_FOLDERS_CREATE_ERROR
        ),
      });

      return null;
    },
    [folders, onCreateFolder, parentFolderID, t]
  );
};
